<template>
  <section class="container-fluid">
    <div class="row">
      <div class="col-12 full-height-page-wrapper">
        <div class="page-table-header">
          <PageHeader showBreadcrumbs page-title="Skills">
            <template #buttons>
              <b-button v-if="$can('create-skills')" class="button" variant="success" v-b-modal.modalSkill>
                Create
              </b-button>
            </template>
          </PageHeader>
        </div>

    <b-modal id="modalSkill" ref="modal" @ok="createSkill" @hidden="resetModal" :modal-class="isModalLoading ? 'loading' : ''" centered>
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">Skill</h5>
        <button type="button" aria-label="Close" class="close" @click.prevent="cancel">
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <b-form ref="form">
        <b-form-group id="name" label="Name:" label-for="name" invalid-feedback="Name is required">
          <b-form-input id="name" type="text" v-model="form.name" required :state="nameState"
            placeholder="Enter name" />
        </b-form-group>
        <b-form-group id="description" label="Description:" label-for="description">
          <b-form-textarea id="description" v-model="form.description" placeholder="Enter description..." rows="3"
            max-rows="6"></b-form-textarea>
        </b-form-group>
      </b-form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="outline" class="button" @click.prevent="cancel">
          Cancel
        </b-button>
        <b-button variant="primary" class="button" @click.prevent="ok">
          <span v-if="form.id">Save</span>
          <span v-else>Create</span>
        </b-button>
      </template>
    </b-modal>

        <div v-if="isLoading" class="content-loading-wrapper" style="min-height: 60vh;">
          <Preloader class="centered-preloader large-spinner" />
        </div>

        <TableForPage v-else-if="skills.length" style="margin-bottom: 0;" :tableData="skills" :fields="fields" :slots="slots"
          :isEdit="$can('update_all-skills')" :isRemove="$can('delete-skills')" @edit="edit" @remove="deleteSkill">
        </TableForPage>

        <div v-else class="full-height-content">
          <EmptyStateNoResults
            customIcon="psychology"
            customIconClasses="material-symbols-outlined empty-state__icon"
            title="No skills added yet"
            description="Define skills to tag users, roles, or tasks and improve search, filtering, and talent management."
            buttonText="CREATE"
            @button-click="handleCreateClick"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import TableForPage from '@tables/TableForPage'
import PageHeader from '@components/PageHeader.vue'
import Preloader from '@components/Preloader'
import EmptyStateNoResults from '@components/EmptyStateNoResults'

export default {
  name: 'skills',
  components: {
    TableForPage,
    PageHeader,
    Preloader,
    EmptyStateNoResults
  },
  data () {
    return {
      fields: [
        {
          label: 'Name',
          key: 'name',
          sortable: true,
          class: 'column-project-name'
        },
        {
          label: 'Description',
          key: 'description',
          sortable: true
        },
        {
          label: 'actions',
          key: 'actions',
          class: 'column_action'
        }
      ],
      skills: [],
      form: {
        id: '',
        name: '',
        description: ''
      },
      nameState: null,
      isLoading: false,
      isModalLoading: false
    }
  },
  methods: {
    deleteSkill (item) {
      this.isLoading = true
      this.axios.post(
        `/api/skill/delete/${item.id}`,
        {},
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        this.getSkills()
        this.$snotify.success(response.data, 'Success', this.$store.state.snotify)
      }).catch(err => {
        this.errorNotifications(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    resetModal () {
      this.form = {
        id: '',
        name: '',
        description: ''
      }
      this.nameState = null
    },
    edit (skill) {
      this.form.id = skill.id
      this.form.name = skill.name
      this.form.description = skill.description
      this.$nextTick(() => {
        this.$refs.modal.show()
      })
    },
    createSkill (e) {
      e.preventDefault()
      // Trigger submit handler
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      if (!valid) {
        return
      }
      var url = ''
      var flag = ''
      if (this.form.id > 0) {
        url = `/api/skill/update/${this.form.id}`
        flag = 'updated'
      } else {
        url = '/api/skill/create'
        flag = 'created'
      }

      this.isModalLoading = true
      this.axios.post(
        url,
        this.form,
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        if (response.status === 200) {
          this.getSkills()
          this.$snotify.success('Skill successfully ' + flag, 'Success', this.$store.state.snotify)
        }
        this.$nextTick(() => {
          this.$refs.modal.hide()
        })
        this.resetModal()
      }).catch(err => {
        this.errorNotifications(err)
      }).finally(() => {
        this.isModalLoading = false
      })
    },
    getSkills () {
      this.isLoading = true
      this.axios({
        method: 'get',
        url: '/api/skills',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then(response => {
          this.skills = response.data
        })
        .catch(console.error)
        .finally(() => {
          this.isLoading = false
        })
    },
    handleCreateClick () {
      this.$refs.modal.show()
    }
  },

  mounted () {
    this.getSkills()
  }
}
</script>
